export const USER_SAVED_SEARCHES_SET = 'USER_SAVED_SEARCHES_SET';
